import React from "react";
import "../styles/ComingSoon.css";

const ComingSoon = ({ onClose }) => {
  return (
    <div className="comingsoon-overlay">
      <div className="comingsoon-box">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>🚀 Coming Soon!</h2>
        <p>We’re working hard to bring you this feature. Stay tuned!</p>
      </div>
    </div>
  );
};

export default ComingSoon;
